module.exports = __webpack_public_path__ + "static/spokoj_full_page-342f1ce228532b4ca20d6846e5c6d6c9.png";